// 兴康线上
const baseURL = '/prod'  // 'http://101.37.30.244:3338/api' //'/prod'  //'/test' //'http://101.37.30.244:3338/api'// '/test' //'/prod' 
// const baseURL = 'http://192.168.111.134:3338/api'

//  const baseURL = 'http://192.168.111.46:3338/api'  //姚
// const baseURL = 'http://192.168.111.43:3338/api'   //汪
// const baseURL = 'http://192.168.111.193:3338/api'   //潘
// const baseURL = 'http://zhyl.hk952183.com/api'

export const uploadVote = baseURL + '/ypt/controller/uploadVotePic/info/uploadPartyVote'
//上传图片地址
export const uploadImg = baseURL + '/ypt/controller/uploadVotePic/info/uploadPartyPhoto'
// 上传图片地址
// export const uploadFilesBaseUrl = 'http://192.168.1.57:8066/api'
export const uploadFilesBaseUrl = 'baseURL' 
// export const uploadFilesBaseUrl = 'http://zhyl.hk952183.com/api'
//上传附件地址

// 组织活动上传视频和上传附件
// export const uploadVote1 = 'http://192.168.1.57:8066/api' + '/controller/uploadVotePic/info/uploadOrgLife'
// export const uploadVote2 = 'http://192.168.1.57:8066/api' + '/admin/consul/info/uplodfiles'

export const uploadVote1 = 'http://101.37.30.244:10001/api' + '/controller/uploadVotePic/info/uploadOrgLife'
export const uploadVote2 = 'http://101.37.30.244:10001/api' + '/admin/consul/info/uplodfiles'
// export const uploadVote1 = 'http://zhyl.hk952183.com/api' + '/controller/uploadVotePic/info/uploadOrgLife'
// export const uploadVote2 = 'http://zhyl.hk952183.com/api' + '/admin/consul/info/uplodfiles'
export default baseURL
